const membershipNumber = (function ($, util) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            copyMembershipNumberButton: '#copy-membership-number'
        },
        func: {
            init: function () {
                if ($(self.elements.copyMembershipNumberButton).length > 0) {
                    self.func.bindEvents();
                }
            },
            bindEvents: function () {
                $(self.elements.copyMembershipNumberButton).on('click', self.func.handleCopyMembershipNumberButtonClick);
            },
            handleCopyMembershipNumberButtonClick: function (event) {
                const gtmCopyMembershipNumber = {
                    event: 'copyMembershipNumber',
                    partnerName: window.location.pathname
                };
                window.dataLayer.push(gtmCopyMembershipNumber);
                const copiedText = $(self.elements.copyMembershipNumberButton).data('copiedtext');
                copyContent(this, copiedText);
                const redirectLink = $(self.elements.copyMembershipNumberButton).data('redirectlink');
                if (redirectLink.length > 0) {
                    event.preventDefault();
                    util.func.openInNewTab(redirectLink);
                }
            }
        }
    };

    return {
        init: self.func.init
    };
})(jQuery, window.Utilities);
$('document').ready(function () {
    window.membershipNumber.init();
});
